<template>
  <el-config-provider :locale="locale">
    <router-view></router-view>
  </el-config-provider>
</template>
<script>
import { watch } from 'vue'
import zhCN from 'element-plus/dist/locale/zh-cn.mjs'
import zhHK from 'element-plus/dist/locale/zh-tw.mjs'
import enUS from 'element-plus/dist/locale/en.mjs'
export default {
  name: 'app',
  data () {
    return {
      // 当前element-plus语言
      locale: this.getLocale()
    }
  },
  // 创建实例时执行
  created () {
    // 获取缓存左侧主题
    const leftComponent = window.localStorage.getItem('leftComponent')
    if (leftComponent) {
      this.$globalData.leftComponent = leftComponent
    }
    // 获取缓存顶部主题
    const topComponent = window.localStorage.getItem('topComponent')
    if (topComponent) {
      this.$globalData.topComponent = topComponent
    }
    // 获取缓存菜单栏是否收缩
    const collapse = window.localStorage.getItem('collapse')
    if (collapse === 'true') {
      this.$globalData.collapse = true
    } else if (collapse === 'false') {
      this.$globalData.collapse = false
    }
  },
  // 页面加载后执行
  mounted () {
    // 移除加载动画
    const load = document.getElementById('Loading')
    load.classList.add('load_hide')
    // 语言变更时触发
    watch(() => this.$i18n.locale,
      () => {
        this.locale = this.getLocale()
      }
    )
  },
  // 自定义方法
  methods: {
    // 获取当前语言并返回对应的element-plus语言
    getLocale () {
      const locale = this.$i18n.locale
      if (locale === 'zhCN') {
        return zhCN
      } else if (locale === 'zhHK') {
        return zhHK
      } else if (locale === 'enUS') {
        return enUS
      } else {
        return zhCN
      }
    }
  }
}
</script>
<style>
html,body,#app{
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  font-family: Inter, 'Helvetica Neue', Helvetica, 'PingFang SC',
  'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}
/* 顶部加载进度条 */
/* 隐藏进度条中的动画圆形 */
#nprogress .bar {
  background: #4096ff !important; /* 设置进度条的颜色 */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  /* 隐藏圆形动画 */
  box-shadow: none !important;
}

/* 隐藏指示器中的圆形 */
#nprogress .peg {
  display: none !important;
}

/* 隐藏指定进度条的动画效果 */
#nprogress .spinner {
  display: none !important;
}
/* 消息框加载动画 */
.custom_loading i{
  animation: customloading 2s linear infinite;
}
@keyframes customloading {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 居中 */
.flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 垂直居中 */
.flex-items-center{
  display: flex;
  align-items: center;
}

/* 水平居中 */
.flex-content-center{
  display: flex;
  justify-content: center;
}

/* 面包屑 */
.top_breadcrumb{
  margin-bottom: 18px;
}

/* 背景阴影 */
.boxshadow{
  border-radius: 8px
}
/* 设置滚动条整体样式 */
::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
  height: 8px; /* 滚动条高度（针对水平滚动条） */
}

/* 设置滚动条轨道（背景） */
::-webkit-scrollbar-track {
  background: transparent; /* 背景透明 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3); /* 滑块颜色 */
  border-radius: 4px; /* 滑块圆角 */
}

/* 设置滚动条滑块悬停状态 */
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5); /* 悬停时滑块颜色 */
}
#app .el-page-header__header{
  line-height: normal;
}
</style>
